export enum AnomalyType {
  Generic = '99',
  Type50 = '50',
  Type82 = '82',
  Type83 = '83',
  Type34 = '34',
  Type71 = '71',
  Type73 = '73',
}
